(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["jeans-size-guide-description"] && !Shopify.designMode) return;
  try {
    function placeJeanDescriptions(root) {
    root.querySelectorAll('.s88-compact-description').forEach((block) => {
      const template = block.querySelector('.s88-jean-description-template');
      const modalContent = block.querySelector('.s88-mo .s88-mw > div');
      if (!template || !modalContent || modalContent.querySelector('.s88-jean-description-in-guide')) return;
      modalContent.append(template.content.cloneNode(true));
    });
  }

  placeJeanDescriptions(document);
  document.addEventListener('shopify:section:load', (event) => placeJeanDescriptions(event.target));
  } catch(e) { console.error(e); }
})();

})();
